import EmptyFactsheet from "../components/Factsheet/EmptyFactsheet"
import Factsheet from "../components/Factsheet/Factsheet"
import { usePath } from "../libs/path/PathProvider"

export default function Factsheets() {
    const {path} = usePath()
    const [_,_page,id] = path.split("/")
    const foodId = parseInt(id)
    return <div id="factsheets">
        {foodId ? <Factsheet foodId={foodId}/> : <EmptyFactsheet/>}
    </div>
}